import React, { useRef, useState, useEffect } from 'react'
import classes from "./CreateHolidayMode.module.css"
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../Modal/Modal';
import Button1 from '../../../Button/Button1';
import UseParseYearMonthDate from '../../../../hooks/UseParseYearMonthDate';
import UseYearMonthDateShort from '../../../../hooks/UseYearMonthDateShort';
import TimeDatePicker from '../../../TimeDatePicker/TimeDatePicker';
import holidayModeIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/__Edit-93.svg"
import StatePicker from './StatePicker';
import UseParseDateMonthYearTime from '../../../../hooks/UseParseDateMonthYearTime';
import { createHolidayModeAPI } from '../../../../../Api Methods/Api';
import Button2 from '../../../Button/Button2';

const CreateHolidayMode = ({ OutPutsPinNames, setShowAutomation, smartLocks, fetchAutomations }) => {
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const inputRef = useRef(null);
    const [update, setUpdate] = useState(0);
    const apiData = {
        token,
        client
    }
    
    const ModalDialog = useRef();
    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        //reset states for scheduled Action
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            // Call the child method
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }

        //reset model screens
        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("Temporary schedule")
    const [modalComponent, setModalComponent] = useState()
    //--------------------------------------------------------------------------------------------
    const [modalPageIndex, setModalPageIndex] = useState(0);

    // Initialize state with current time
    const [holidayModeDetails, setHolidayModeDetails] = useState(
        {
            "deviceUUID": DeviceUUID,
            "start": "",
            "end": "",
            "name": "",
            "active": 1,
            "states": { "5": "ignore", "6": "ignore", "13": "ignore", "19": "ignore" }
        }
    );

    // Handler for time change
    const HandleStartOn = (object) => {
        setHolidayModeDetails(prevState => ({
            ...prevState, // Spread the previous state to keep other properties unchanged
            start: object // Update only the start property
        }));
    };

    const HandleEndOn = (object) => {
        setHolidayModeDetails(prevState => ({
            ...prevState,
            end: object
        }));
    };

    const HandleSetName = (object) => {
        setHolidayModeDetails(prevState => ({
            ...prevState, // Spread the previous state to keep other properties unchanged
            name: object.current?.value?.trim() // Update only the start property
        }));
    }

    const HandleOutputState = (pin, state) => {
        const states = holidayModeDetails.states
        states[pin] = state;

        setHolidayModeDetails(prevState => ({
            ...prevState, // Spread the previous state to keep other properties unchanged
            "states": states // Update only the start property
        }));
    }
    const dispatch = useDispatch();

    const HandleCreateHolidayMode = async () => {
        if ((holidayModeDetails.start != holidayModeDetails.end) && holidayModeDetails.name !== "") {
            const response = await createHolidayModeAPI(apiData, holidayModeDetails, dispatch);
            if (response && response.success) {
                HandleCloseModal();
                fetchAutomations();
            }
        }
    }

    if (holidayModeDetails.start == holidayModeDetails.end) {
    }


    const [isHolidayModeValid, setisHolidayModeValid] = useState(false);

    useEffect(() => {
            //checks if the start at time and date matches the end at time and date - if so then disable next page button
            if ((holidayModeDetails.start != holidayModeDetails.end) && holidayModeDetails.name !== ""){
                setisHolidayModeValid(true);
            } else {
                setisHolidayModeValid(false)
            }
        
    }, [holidayModeDetails])


    const handleInputChange = (update) => {
        setUpdate(update + 1); // Increment `update` when the input changes
    };


    // re-render modal to show new modal componet. 
    useEffect(() => {
        switch (modalPageIndex) {
            case 0:

                setModalComponent(
                    <div className={classes["timeDatePicker-Container"]}> 
                        <h2 style={{color:"#6e6e6e"}}>Create temporary schedule</h2>
                       
                        <input
                            style={{minHeight:"50px"}}
                            placeholder={"Enter a name"}
                            type="text"
                            className={classes.input}
                            ref={inputRef} 
                            onChange={() => HandleSetName(inputRef)}/>
                            <br></br>
                        <TimeDatePicker handler={HandleStartOn} label={"Start at"} />
                        <br></br>
                        <TimeDatePicker handler={HandleEndOn} label={"End at"} />
                        <br></br>
                        <Button2 style={{minWidth:"480px"}}className={classes.nextButton} disabled={!isHolidayModeValid} onClick={() => setModalPageIndex(1)}>Next</Button2>
                    </div>
                )

                break;
            case 1:


                //removed to match app availablePins
                // Filter for only active pins && pins with type of latch 
                // const availablePins = OutPutsPinNames.filter(outPut => outPut.active == '1' && outPut.type == 'LATCH');



                //remove all outputs that have a smartLock assinged to it.
                let LatchPins = OutPutsPinNames;
                if (smartLocks.length != 0) {
                    LatchPins = OutPutsPinNames.filter(outPut =>
                        smartLocks.some(smartLock => outPut.Pin != smartLock.outputPin)
                    );
                }


                // set all pins that are of type latch to arm - since the statePicker will default the selected state to arm on modal page load
                if (LatchPins.length != 0) {
                    LatchPins.map((latchOutput) => {
                        HandleOutputState(latchOutput.Pin, "arm");
                    })
                }

                // get all pulse pins
                const pulsePins = OutPutsPinNames.filter(outPut => (outPut.type == 'PULSE' || outPut.type == 'VIRTUAL_PULSE'));

                // set the pins in holidayDetails.states object to "pulse", if the are of type pulse
                if (pulsePins.length != 0) {
                    pulsePins.map((pulseOutput) => {
                        HandleOutputState(pulseOutput.Pin, "pulse");
                    })
                }

                // get all pins that have smartLock assinged to it
                let smartLockPins = OutPutsPinNames.filter(outPut =>
                    smartLocks.some(smartLock => outPut.Pin == smartLock.outputPin)
                );

                // for all pins that have a smart lock assinged to them, set the states of thoese pins to "lock" within holidaymode details.
                if (smartLockPins.length != 0) {
                    smartLockPins.map((smartLockOutput) => {
                        HandleOutputState(smartLockOutput.Pin, "lock");
                    })
                }

                setModalComponent(
                    <div className={classes["statePicker-Container"]}>
                        <h2 style={{color:"#6e6e6e"}}>What should the switches do during the schedule?</h2>
                        <br></br>
                        {LatchPins.map((outPut) => {
                            if (outPut.type == "LATCH" || outPut.type == "VIRTUAL_LATCH") {
                                return (
                                    <StatePicker pinText={outPut.pinName} outputPin={outPut.Pin} HandleOutputState={HandleOutputState} states={holidayModeDetails.states[outPut.Pin]} />
                                )
                            }
                        })}
                        <br></br>
                        <div style={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        gap: "15px" 
                        }}>
                            <Button2 style={{minWidth:"350px"}}className={classes.nextButton} onClick={() => setModalPageIndex(0)}>Back</Button2>
                            <Button2 style={{minWidth:"350px"}}className={classes.nextButton} onClick={HandleCreateHolidayMode}>Save</Button2>
                        </div>
                    </div>
                );
                break;
        }
        HandleShowModal()
    }, [modalPageIndex, isHolidayModeValid])


    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setModalPageIndex(0);
        setShowAutomation(null);
    }


    return (

        <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
            {modalComponent}
        </Modal>
    )
}

export default CreateHolidayMode